import { createRouteRef, createApiRef, createPlugin, createApiFactory, discoveryApiRef, identityApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';

const rootRouteRef = createRouteRef({
  id: "blackduck"
});

const blackduckApiRef = createApiRef({
  id: "plugin.blackduck.service"
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BlackDuckClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "identityApi");
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }
  async getVulns(projectName, projectVersion) {
    const baseUrl = `${await this.discoveryApi.getBaseUrl("blackduck")}`;
    const vulnURL = `${baseUrl}/vulns/${projectName}/${projectVersion}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(vulnURL, {
      headers: {
        "Content-Type": "application/json",
        ...idToken && { Authorization: `Bearer ${idToken}` }
      }
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
  async getRiskProfile(projectName, projectVersion) {
    const baseUrl = `${await this.discoveryApi.getBaseUrl("blackduck")}`;
    const vulnURL = `${baseUrl}/risk-profile/${projectName}/${projectVersion}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(vulnURL, {
      headers: {
        "Content-Type": "application/json",
        ...idToken && { Authorization: `Bearer ${idToken}` }
      }
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

const blackduckPlugin = createPlugin({
  id: "blackduck",
  apis: [
    createApiFactory({
      api: blackduckApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef
      },
      factory: ({ discoveryApi, identityApi }) => new BlackDuckClient({
        discoveryApi,
        identityApi
      })
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const BlackDuckPage = blackduckPlugin.provide(
  createRoutableExtension({
    name: "BlackDuckPage",
    component: () => import('./index-254a41b5.esm.js').then((m) => m.BlackDuckPageComponent),
    mountPoint: rootRouteRef
  })
);
const BlackDuckCard = blackduckPlugin.provide(
  createRoutableExtension({
    name: "BlackDuckCard",
    component: () => import('./index-0d965fb7.esm.js').then((m) => m.BlackDuckCardComponent),
    mountPoint: rootRouteRef
  })
);
const RiskCard = blackduckPlugin.provide(
  createRoutableExtension({
    name: "RiskCard",
    component: () => import('./index-0d965fb7.esm.js').then((m) => m.RiskCardComponent),
    mountPoint: rootRouteRef
  })
);

const BLACKDUCK_PROJECT_ANNOTATION = "blackduck/project";
const isBlackDuckAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[BLACKDUCK_PROJECT_ANNOTATION]);
};
const getProjectAnnotation = (entity) => {
  var _a;
  let projectName = void 0;
  let projectVersion = void 0;
  const annotation = (_a = entity == null ? void 0 : entity.metadata.annotations) == null ? void 0 : _a[BLACKDUCK_PROJECT_ANNOTATION];
  if (annotation) {
    [projectName, projectVersion] = annotation.split("/");
  }
  return { projectName, projectVersion };
};

export { BLACKDUCK_PROJECT_ANNOTATION as B, RiskCard as R, blackduckPlugin as a, blackduckApiRef as b, BlackDuckPage as c, BlackDuckCard as d, getProjectAnnotation as g, isBlackDuckAvailable as i };
//# sourceMappingURL=index-92f6a896.esm.js.map
